<template>
  <form :onsubmit="sendReview" id="reviewForm" class="flex items-center mb-4">
    <textarea
      v-model="newReview"
      required
      rows="3"
      minlength="4"
      class="flex-1 p-1 bg-gray-50"
      placeholder="Tell us how you liked this menu"
    />
    <button
      class=""
      :disabled="sendingReview"
      form="reviewForm"
      type="submit"
      aria-label="send review"
    >
      <img
        alt="image"
        v-if="sendingReview"
        class="h-6 mx-2 animate-spin"
        src="@/assets/icons/spinner.svg"
      />
      <img
        alt="image"
        v-else
        class="h-6 mx-2 transform rotate-45"
        src="@/assets/icons/send.svg"
      />
    </button>
  </form>
</template>
<script>
import firebase from "firebase/app";
export default {
  props: {
    menuID: String,
  },
  data() {
    return {
      sendingReview: false,
      newReview: "",
    };
  },
  methods: {
    sendReview() {
      if (firebase.auth().currentUser) {
        this.sendingReview = true;
        firebase
          .firestore()
          .collection("Reviews")
          .doc(this.menuID)
          .collection("reviews")
          .doc()
          .set({
            review: this.newReview,
            displayName:
              firebase.auth().currentUser?.displayName ?? "Anonymous",
            timestamp: Date.now(),
            user: firebase.auth().currentUser?.uid ?? "Anonymous",
          })
          .then(() => {
            this.sendingReview = false;
            this.newReview = "";
            this.$toast.info("Review Sent!", {
              position: "bottom",
              duration: 2000,
            });
          })
          .catch((error) => {
            this.sendingReview = false;
            this.$toast.error(error.message, {
              position: "bottom",
              duration: 4000,
            });
          });
      } else {
        this.$toast.error("Sign in to review our menu!", {
          position: "bottom",
          duration: 1000,
        });
      }
      return false;
    },
  },
};
</script>
